__turbopack_context__.v({
  "className": "gu_cFW_className",
  "variable": "gu_cFW_variable",
});
